function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/ico-30-cloud-download");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/ico-30-cloud-download",
  stroke: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11,20.5 L8.5,20.5 C5.26160306,20.5 2.62242824,17.9344251 2.50413847,14.7249383 L2.5,14.5 C2.5,11.1862915 5.1862915,8.5 8.5,8.5 C8.64184239,8.5 8.78253521,8.50492194 8.92191696,8.51460436 C9.94692988,5.59410688 12.7289125,3.5 16,3.5 C20.1421356,3.5 23.5,6.85786438 23.5,11 C23.5,11.1770492 23.4938652,11.3526655 23.4817965,11.526648 C25.7404327,11.7658023 27.5,13.6774167 27.5,16 C27.5,18.4142733 25.5987635,20.3844891 23.2118357,20.495102 L23,20.5 L20,20.5",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5,19.5 L15.4745223,15.5 M19.5,19.5 L15.4745223,15.5 M15.5,16 L15.5,27.5",
  id: "Combined-Shape",
  transform: "translate(15.500000, 21.500000) scale(1, -1) translate(-15.500000, -21.500000) "
})));

const SvgIco30CloudDownload = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30CloudDownload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-cloud-download.f4e7b95b.svg";
export { ForwardRef as ReactComponent };